module.exports = __webpack_public_path__ + "img/souS.288097ea.png";